<template>
  <v-card v-if="event" class="mx-auto reserve-card" outlined>
    <!-- 關閉按鈕 -->
    <v-btn
      fab
      icon
      absolute
      width="48"
      height="48"
      style="top: 0; right: 0; overflow: hidden;"
      @click="$emit('close')"
    >
      <v-icon>mdi-close</v-icon>
    </v-btn>

    <!-- Type 1 & 2: 患者資料區 + 傳送選單 -->
    <v-card-title v-if="event.reserve_type !== '3'" style="max-height: 180px; overflow-x: auto">
      <v-list-item three-line class="px-1" style="max-width: 100%;" :loading="loadingDetail">
        <v-list-item-avatar :size="$vuetify.breakpoint.xsOnly ? 60 : 80" color="grey">
          <v-img :src="event.file_name_photo"/>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title
            class="text-h5 mb-1 d-flex align-center"
            :class="{'flex-wrap': $vuetify.breakpoint.smAndDown}"
          >
            <div class="align-bottom">
              {{ event.name }}
            </div>
            <!-- 傳送訊息給患者下拉選單 -->
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  text
                  v-bind="attrs"
                  v-on="on"
                  class="primary mr-1 ml-auto"
                >
                  傳送訊息給患者
                </v-btn>
              </template>
              <v-list dense outlined class="text-body-2">
                <v-list-item
                  class="justify-center"
                  @click="handleRemind"
                  :loading="sending"
                  :disabled="sending"
                >
                  立即傳送
                </v-list-item>
                <SendMessageChannelMenu
                  v-if="event.reserve_type !== '3'"
                  activator-type="list-item"
                  activator-text="自行輸入內容"
                  :patient="{
                    patientName: event.name,
                    patientCode: event.patient_code,
                    patientPhone: event.phone,
                  }"
                />
              </v-list>
            </v-menu>
          </v-list-item-title>
          <v-list-item-subtitle class="d-flex align-center">
            <div v-for="(item, i) in info" :key="i" class="d-flex align-center mr-2">
              <v-img
                v-if="item.isImage"
                :src="item.icon"
                max-width="16"
                width="16"
                class="mr-1"
              />
              <v-icon v-else class="mr-1" size="16">
                {{ item.icon }}
              </v-icon>
              <div>
                {{ item.value }}
              </div>
            </div>
            <!-- 綁定狀態說明對話框 -->
            <v-dialog v-if="fullEventData && fullEventData.bind_status !== undefined" v-model="bindStatusDialog" width="fit-content">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon x-small v-bind="attrs" v-on="on">
                  <v-icon size="16">mdi-help-circle-outline</v-icon>
                </v-btn>
              </template>

              <v-card>
                <v-card-title class="grey-7--text font-weight-bold">
                  患者綁定狀態
                </v-card-title>

                <v-card-text>
                  <div v-if="fullEventData.bind_status === '0'">
                    <div class="d-flex align-center">
                      <v-img :src="showBindStatus({status: fullEventData.bind_status}).icon" max-width="20" width="20" class="mr-1"/>
                      <div class="text-body-2">沒有任何綁定的紀錄</div>
                    </div>
                  </div>
                  <template v-else>
                    <div v-for="(status, idx) in bindStatusDetail" :key="idx" class="d-flex align-center mb-2">
                      <v-img :src="status.icon" max-width="20" width="20" class="mr-1"/>
                      <div class="text-body-2" v-html="status.text"/>
                    </div>
                  </template>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-list-item-subtitle>
          <!-- 患者備註 -->
          <v-list-item-subtitle v-if="fullEventData && fullEventData.patient_note" class="d-flex flex-nowrap align-center">
            <div style="text-overflow: ellipsis; overflow:hidden; white-space: nowrap; width: 70%;">
              患者備註 {{ fullEventData.patient_note }}
            </div>
            <v-dialog max-width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  x-small
                  text
                  color="tiffany-6"
                  class="ml-1"
                >
                  更多
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  患者備註
                </v-card-title>
                <v-card-text class="text-pre-line" v-text="fullEventData.patient_note"/>
              </v-card>
            </v-dialog>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-card-title>

    <!-- Type 3: 簡化標題 -->
    <v-card-title v-else>
      <span>{{ typeTitle }}</span>
    </v-card-title>

    <v-divider></v-divider>

    <!-- Body 資訊區 -->
    <v-card-text style="height: fit-content;">
      <v-row no-gutters dense>
        <v-col cols="12">
          <v-card-title class="justify-space-between">
            {{ event.reserve_type === '3' ? '備註資訊' : '提醒資訊' }}
          </v-card-title>
          <v-card-text class="pt-0 reserve-info">
            <v-row dense>
              <v-col cols="12" sm="6">
                <div>&#8231; 日期
                  <span class="black--text">{{ forceTaiwanTimestamp(event.start_time) | formatDate('YYYY-MM-DD') }}</span>
                </div>
                <div v-if="sendTime">發送時間
                  <span class="black--text">{{ sendTime }}</span>
                </div>
                <div v-if="event.doctor_name">&#8231; 醫師
                  <span class="black--text">{{ event.doctor_name }}</span>
                </div>
                <div v-if="event.clinic_name">&#8231; 診所
                  <span class="black--text">{{ event.clinic_name }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div v-if="event.remind_others">&#8231; 額外提醒
                  <span class="black--text">{{ event.remind_others }}</span>
                </div>
                <div v-if="event.note">&#8231; {{ event.reserve_type === '3' ? '備註內容' : '診所內備註' }}
                  <span class="black--text">{{ event.note }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-col>
      </v-row>
    </v-card-text>

    <v-divider></v-divider>

    <!-- 底部按鈕 -->
    <v-card-actions>
      <v-btn color="red-6" dark @click="handleDelete" :disabled="deleting || sending">
        刪除
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('close')" :disabled="deleting || sending">關閉</v-btn>
      <v-btn color="primary" @click="handleEdit" :disabled="deleting || sending">
        編輯
      </v-btn>
    </v-card-actions>

    <!-- 刪除確認對話框 -->
    <v-dialog v-model="deleteConfirmDialog" max-width="400">
      <v-card>
        <v-card-title>確認刪除</v-card-title>
        <v-card-text>
          確定要刪除這個{{ typeTitle }}嗎？此操作無法復原。
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteConfirmDialog = false" :disabled="deleting">取消</v-btn>
          <v-btn color="error" text :loading="deleting" :disabled="deleting" @click="confirmDelete">確定刪除</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-card>
</template>

<script>
import {
  deleteReserveSpecifyAPI,
  remindReserveSpecifyAPI,
  getReserveSpecifyDetailAPI
} from '@/api';
import { mapGetters } from 'vuex';
import { formatDate, formatROCDate, assetURL } from '@/utils/filters';
import { forceTaiwanTimestamp } from "@/utils/timezoneHelper";
import { bindStatus } from '@/config/bindConfig';
import SendMessageChannelMenu from "@/components/utils/SendMessageChannelMenu.vue";

// 發送時間配置（未來可擴展為可編輯的下拉選單）
const SEND_TIME_CONFIG = {
  1: '09:00',  // 定檢 6M
  2: '09:10',  // 額外提醒
  4: '09:00',  // 定檢 3M
  // Type 3（備註）不需要發送時間
};

export default {
  name: 'AllDayEventDetail',
  components: {
    SendMessageChannelMenu
  },
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      deleteConfirmDialog: false,
      deleting: false,
      sending: false,
      forceTaiwanTimestamp,
      fullEventData: null, // 完整事件資料（包含 bind_status）
      loadingDetail: false,
      bindStatusDialog: false
    };
  },
  computed: {
    ...mapGetters(['axiosParamData', 'clinicUser', 'doctorUser']),
    typeTitle() {
      const titles = {
        '1': '定檢提醒（6M）',
        '2': '額外提醒',
        '3': '備註',
        '4': '定檢提醒（3M）'
      };
      return titles[this.event.reserve_type] || '事件';
    },
    // 發送時間（根據 reserve_type 決定）
    sendTime() {
      const reserveType = String(this.event.reserve_type);
      return SEND_TIME_CONFIG[reserveType] || null;
    },
    info() {
      const eventData = this.fullEventData || this.event;
      const info = [];

      if (parseInt(eventData.sex) === 0) {
        info.push({ icon: 'mdi-gender-female', value: '女' });
      } else if (parseInt(eventData.sex) === 1) {
        info.push({ icon: 'mdi-gender-male', value: '男' });
      }

      if (eventData.birthday) {
        info.push({ icon: 'mdi-cake-variant', value: formatROCDate(forceTaiwanTimestamp(parseInt(eventData.birthday))) });
      }

      if (eventData.phone) {
        info.push({ icon: 'mdi-cellphone-iphone', value: eventData.phone });
      }

      // 綁定狀態（只在有完整資料時顯示）
      if (this.fullEventData && this.fullEventData.bind_status !== undefined) {
        const bindInfo = this.showBindStatus({ status: this.fullEventData.bind_status });
        info.push({
          icon: bindInfo.icon,
          value: bindInfo.text,
          isImage: true
        });
      }

      return info;
    },
    bindStatusDetail() {
      if (!this.fullEventData) return [];

      const bindStatus = [];
      const configs = [];

      if (this.clinicUser) {
        if (this.fullEventData.clinic_oa_status) {
          configs.push(
            { bindStatusKey: 'line', eventStatusKey: 'clinic_oa_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'clinic_fb_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'line', eventStatusKey: 'doctor_oa_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'doctor_fb_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true }
          );
        } else {
          configs.push(
            { bindStatusKey: 'line', eventStatusKey: 'dentco_oa_status', name: '小幫手公用', hiddenNull: false },
            { bindStatusKey: 'messenger', eventStatusKey: 'clinic_fb_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'line', eventStatusKey: 'doctor_oa_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'doctor_fb_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true }
          );
        }
      } else {
        if (this.fullEventData.doctor_oa_status) {
          configs.push(
            { bindStatusKey: 'line', eventStatusKey: 'clinic_oa_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'clinic_fb_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'line', eventStatusKey: 'doctor_oa_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'doctor_fb_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true }
          );
        } else {
          configs.push(
            { bindStatusKey: 'line', eventStatusKey: 'dentco_oa_status', name: '小幫手公用', hiddenNull: false },
            { bindStatusKey: 'messenger', eventStatusKey: 'clinic_fb_status', name: this.fullEventData.clinic_name, hiddenNull: true },
            { bindStatusKey: 'line', eventStatusKey: 'doctor_oa_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true },
            { bindStatusKey: 'messenger', eventStatusKey: 'doctor_fb_status', name: `${this.fullEventData.doctor_name}醫師`, hiddenNull: true }
          );
        }
      }

      configs.forEach(config => {
        if (!config.hiddenNull || this.fullEventData[config.eventStatusKey])
          bindStatus.push(
            this.showBindStatus({
              key: config.bindStatusKey,
              status: this.fullEventData[config.eventStatusKey],
              name: config.name
            })
          );
      });

      return bindStatus;
    }
  },
  mounted() {
    // 如果是 Type 1 & 2（定檢/額外提醒），取得完整資料包含 bind_status
    if (this.event.reserve_type !== '3' && this.event.reserve_no) {
      this.loadFullEventData();
    }
  },
  methods: {
    async loadFullEventData() {
      this.loadingDetail = true;
      try {
        const res = await getReserveSpecifyDetailAPI(this.event.reserve_no, this.axiosParamData);
        this.fullEventData = res.data;
      } catch (error) {
        console.error('載入完整事件資料失敗:', error);
      } finally {
        this.loadingDetail = false;
      }
    },

    showBindStatus(config) {
      const assetConfig = bindStatus(config);
      return {
        icon: assetURL(assetConfig.icon),
        text: assetConfig.text
      };
    },

    handleEdit() {
      this.$emit('edit', this.event);
    },

    handleDelete() {
      this.deleteConfirmDialog = true;
    },

    async handleRemind() {
      this.sending = true;
      try {
        const payload = {
          ...this.axiosParamData,
          reserve_no: this.event.reserve_no
        };

        await remindReserveSpecifyAPI(payload);
        this.$emit('reminded');
      } catch (error) {
        console.error('發送提醒失敗:', error);
        this.$emit('error', error);
      } finally {
        this.sending = false;
      }
    },

    async confirmDelete() {
      this.deleting = true;
      try {
        const payload = {
          ...this.axiosParamData,
          attend_status: '6' // 軟刪除
        };
        await deleteReserveSpecifyAPI(this.event.reserve_no, payload);
        this.$emit('deleted');
        this.deleteConfirmDialog = false;
      } catch (error) {
        console.error('刪除失敗:', error);
        this.$emit('error', error);
      } finally {
        this.deleting = false;
      }
    }
  }
};
</script>

<style scoped>
.reserve-card .v-list-item__subtitle {
  -webkit-line-clamp: unset;
}

.reserve-info > .row > .col {
  font-size: 14px;
  line-height: 1.8;
  color: #666;
}

.reserve-info .black--text {
  font-weight: 500;
}
</style>
